import { TablePaginationConfig } from 'antd'
import { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { DeviceErrorsPageHeader, DeviceErrorsTable } from '@/components/pages/Client/ListDeviceError'
import routes from '@/constants/routes'
import useQueryPage from '@/hooks/useQueryPage'

import { useDeviceError } from './DeviceError.hooks'

const DeviceError = () => {
  const params = useParams<{ id: string }>()
  const [searchParams] = useSearchParams()
  const currentPage = useQueryPage()
  const navigate = useNavigate()
  const { deviceErrorResponse, getErrorDevice, loading, page, pageSize, setPage } = useDeviceError()
  const dataSource = deviceErrorResponse?.items ?? []
  const totalItems = deviceErrorResponse?.meta.totalItems || 0
  const deviceId = Number(params.id)
  const dateSearch = searchParams.get('date')

  const handleChangePage = (config: TablePaginationConfig) => {
    setPage(config.current ?? page)
    navigate({
      pathname: routes.deviceError.path,
      search: `?page=${config.current ?? page}`,
    })
  }

  useEffect(() => {
    if (currentPage) {
      setPage(currentPage)
    }
  }, [currentPage, setPage])

  useEffect(() => {
    getErrorDevice({ date: dateSearch ? dateSearch : undefined })
  }, [dateSearch, deviceId, getErrorDevice])

  return (
    <>
      <DeviceErrorsPageHeader />
      <DeviceErrorsTable {...{ dataSource, loading, page, totalItems, pageSize }} onChange={handleChangePage} />
    </>
  )
}

DeviceError.displayName = 'DeviceError'
export default DeviceError
